import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-softer py-14 px-4 md:px-8" data-id="element-78">
      <div className="max-w-xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border-2 border-secondary/30 rounded-2xl p-8 text-center" data-id="element-80">
          <div className="bg-bg-mint w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-81">
            <ShieldCheckIcon className="w-8 h-8 text-accent" data-id="element-82" />
          </div>

          <h2 className="text-xl md:text-2xl font-serif text-text-dark mb-4" data-id="element-83">
            🔒 Probalo sin riesgo — 7 días de garantía total
          </h2>

          <p className="text-primary-mid mb-4" data-id="element-84">
            Tenés 7 días completos para probarlo.
          </p>

          <p className="text-primary-mid mb-4" data-id="element-85">
            Si no sentís cambios, claridad o mejoras…
          </p>

          <p className="text-accent font-semibold text-lg mb-4" data-id="element-86">
            👉 te devolvemos el 100% del dinero
          </p>

          <p className="text-primary-mid/70 text-sm" data-id="element-87">
            Sin preguntas. Sin trámites.
            <br data-id="element-88" />
            <span className="font-medium text-text-dark" data-id="element-89">
              El riesgo es mío, no tuyo.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}